import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Header, Segment, Form, Dropdown } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag } from "@fortawesome/free-solid-svg-icons";

export const KEY_LABEL_TYPES = {
  STANDARD: 1,
  BASIC: 2,
};

export const KEY_LABEL_LAYOUT = {
  A4: 1,
  LABEL: 2,
  KIOSK_LABEL: 3,
  KEY_TAG: 4,
  ALTEC_QR: 5,
  LABEL_LONG: 6,
};

export const getKeyLabelLayoutOptions = t => [
  { text: "A4", value: KEY_LABEL_LAYOUT.A4, key: KEY_LABEL_LAYOUT.A4 },
  { text: `${t("label").message || "Label"} - 29 × 62 mm`, value: KEY_LABEL_LAYOUT.LABEL, key: KEY_LABEL_LAYOUT.LABEL },
  { text: `${t("label").message || "Label"} - 29 × 90 mm`, value: KEY_LABEL_LAYOUT.LABEL_LONG, key: KEY_LABEL_LAYOUT.LABEL_LONG },
  { text: `${t("kiosk_label").message || "Kiosk Label"} - 19.1 × 279.4 mm`, value: KEY_LABEL_LAYOUT.KIOSK_LABEL, key: KEY_LABEL_LAYOUT.KIOSK_LABEL },
  { text: `${t("keytag").message || "Keytag"} - 35 × 108 mm`, value: KEY_LABEL_LAYOUT.KEY_TAG, key: KEY_LABEL_LAYOUT.KEY_TAG },
  { text: "Altec QR", value: KEY_LABEL_LAYOUT.ALTEC_QR, key: KEY_LABEL_LAYOUT.ALTEC_QR },
];

class KeyLabelConfiguration extends Component {
  handleDropdownChange = (e, { name, value }) => {
    let { location, onLocationChange } = this.props;

    onLocationChange({ ...location, [name]: value });
  };

  render() {
    const { t, location, isSubmit } = this.props;

    const dropdownOptions = Object.entries(KEY_LABEL_TYPES).map(([key, value]) => ({
      key,
      value,
      text: t(key.toLocaleLowerCase()).message || `${key[0]}${key.slice(1).toLocaleLowerCase()}`,
    }));

    const layoutOptions = getKeyLabelLayoutOptions(t);

    return (
      <Segment>
        <Header as="h5">
          <FontAwesomeIcon icon={faTag} className="-margin-right-5" />
          <Header.Content>{t("key_label_settings").message || "Key Label Settings"}</Header.Content>
        </Header>
        <Form>
          <Form.Field className="full-width-input">
            <label>{t("label_format").message || "Label format"}</label>
            <Dropdown
              options={dropdownOptions}
              value={location.key_label_type_id}
              onChange={this.handleDropdownChange}
              name="key_label_type_id"
              selectOnBlur={false}
              selection
              fluid
              disabled={isSubmit}
            />
          </Form.Field>
          <Form.Field className="full-width-input">
            <label>{t("label_printers").message || "Label printers"}</label>
            <Dropdown
              options={layoutOptions}
              value={location.key_label_layout_id}
              onChange={this.handleDropdownChange}
              name="key_label_layout_id"
              selectOnBlur={false}
              selection
              fluid
              disabled={isSubmit}
            />
          </Form.Field>
        </Form>
      </Segment>
    );
  }
}

export default withTranslation()(KeyLabelConfiguration);
